import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useApp, telLink, mailLink, PHONE_DISPLAY, EMAIL } from "@/context/AppContext";

const Footer = () => {
  const { tr } = useApp();
  const quick = [
    { to: "/about", label: tr.nav.about },
    { to: "/brands", label: tr.nav.brands },
    { to: "/categories", label: tr.nav.categories },
    { to: "/search", label: tr.nav.search },
    { to: "/fleet", label: tr.nav.fleet },
    { to: "/quotation", label: tr.nav.quotation },
    { to: "/faq", label: tr.nav.faq },
    { to: "/privacy", label: tr.privacyTitle },
    { to: "/terms", label: tr.termsTitle },
  ];
  return (
    <footer className="relative z-10 bg-[#0a0a0a] border-t border-[#27272a] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <Logo />
          <p className="text-zinc-400 text-sm mt-4 leading-relaxed">{tr.footer.about}</p>
          <div className="flex gap-3 mt-5">
            {[Instagram, Facebook, Linkedin].map((Icon, i) => (
              <a key={i} href="#" aria-label="social" data-testid={`social-link-${i}`}
                 className="h-9 w-9 flex items-center justify-center border border-[#27272a] hover:border-[#EAB308] hover:text-[#EAB308] text-zinc-400 transition-colors">
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-en-head font-bold text-white uppercase tracking-wider text-sm mb-4">{tr.footer.quick}</h4>
          <ul className="space-y-2">
            {quick.map((q) => (
              <li key={q.to}><Link to={q.to} className="text-zinc-400 text-sm hover:text-[#EAB308] transition-colors">{q.label}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-en-head font-bold text-white uppercase tracking-wider text-sm mb-4">{tr.footer.contactH}</h4>
          <ul className="space-y-3 text-sm text-zinc-400">
            <li><a href={telLink} className="flex items-center gap-2 hover:text-[#EAB308]"><Phone className="h-4 w-4 text-[#EAB308]" />{PHONE_DISPLAY}</a></li>
            <li><a href={mailLink} className="flex items-center gap-2 hover:text-[#EAB308]"><Mail className="h-4 w-4 text-[#EAB308]" />{EMAIL}</a></li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#EAB308]" />{tr.hero.head}</li>
            <li className="flex items-center gap-2 text-[#006C35]"><span className="h-2 w-2 rounded-full bg-[#006C35]" />{tr.footer.about ? tr.coverage : ""}</li>
          </ul>
        </div>

        <div>
          <h4 className="font-en-head font-bold text-white uppercase tracking-wider text-sm mb-4">{tr.footer.disclaimerH}</h4>
          <p className="text-zinc-500 text-xs leading-relaxed">{tr.brandsDisclaimer}</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-6 border-t border-[#27272a] flex flex-col sm:flex-row justify-between items-center gap-3">
        <p className="text-zinc-500 text-xs">© {new Date().getFullYear()} Aalam Al-Itarat — عالم الإطارات. {tr.footer.rights}</p>
        <p className="text-zinc-500 text-xs">{tr.tagline}</p>
      </div>
    </footer>
  );
};

export default Footer;
